export interface Winning {
    gameId: string;
    eventId: string;
    eventName: string;
    eventOfflinePaymentMarked: boolean;
    eventOrganizer: string;
    dateOfEvent: string;
    releaseFormAccepted: boolean;
    paymentRestricted: boolean;
    paymentStatus: string;
    prizeId: string;
    prizeType: string;
    paymentAmount: number;
    taxInterviewUrl?: string;
    winningAmount: number;
    withholdingAmount: number;
    markedOfflinePay?: boolean;
}

export interface PrizeData {
    identityId: string;
    identityTaxVerified: boolean;
    identityTaxStatus: string;
    identityEmailAddress: string;
    paymentHandler: string;
    winnings: Winning[];
    offlinePayment: boolean;
}

export interface PrizeState {
    loading: boolean;
    error: string | null;
    data: PrizeData | null;
    loaded?: boolean;
}

export const PRIZE_DEFAULT_STATE: PrizeState = {
    loading: false,
    error: null,
    data: null,
    loaded: false
};
